/*
=========================================================
* RingOperator Final CTA — full-bleed waveform
=========================================================
*/

import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

import { brandPrimary, brandCream, brandAccent } from "pages/RingOperatorHomepage/theme";
import Waveform from "pages/RingOperatorHomepage/sections/Waveform";
import useSignupUrl from "hooks/useSignupUrl";
import { getDisplayTrialDays } from "constants/promo";

function FinalCTA() {
  const signupUrl = useSignupUrl();

  return (
    <MKBox
      component="section"
      className="ro-root"
      sx={{ background: brandPrimary, color: brandCream, position: "relative", overflow: "hidden" }}
    >
      <MKBox
        sx={{
          position: "absolute",
          inset: 0,
          color: brandAccent,
          opacity: 0.22,
          pointerEvents: "none",
        }}
      >
        <Waveform bars={120} height={600} speed={0.6} variance={1.3} />
      </MKBox>

      <Container sx={{ position: "relative", py: { xs: 10, md: 16 }, textAlign: "center" }}>
        <MKBox
          className="ro-mono"
          sx={{
            fontSize: 12,
            color: brandAccent,
            textTransform: "uppercase",
            letterSpacing: "0.18em",
            mb: 3,
          }}
        >
          ◦ Ready when you are
        </MKBox>
        <MKTypography
          component="h2"
          sx={{
            m: 0,
            fontSize: { xs: "2.8rem", sm: "4.5rem", md: "7rem" },
            lineHeight: 0.9,
            letterSpacing: "-0.045em",
            fontWeight: 800,
            color: brandCream,
          }}
        >
          Stop missing
          <br />
          <MKBox component="span" className="ro-serif" sx={{ fontStyle: "italic" }}>
            money.
          </MKBox>
        </MKTypography>

        <MKTypography
          sx={{
            color: "rgba(244,241,234,0.7)",
            fontSize: { xs: "1.05rem", md: "1.2rem" },
            mt: 3,
            maxWidth: 560,
            mx: "auto",
            lineHeight: 1.55,
          }}
        >
          RingOperator answers your phone so you don&apos;t have to. {getDisplayTrialDays()}-day
          free trial. Cancel anytime.
        </MKTypography>

        <MKBox
          sx={{
            mt: 5,
            display: "flex",
            gap: 1.5,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <MKButton
            size="large"
            onClick={() => (window.location.href = signupUrl)}
            sx={{
              background: `${brandAccent} !important`,
              color: "#fff !important",
              px: 4,
              py: 2,
              borderRadius: 999,
              fontSize: "1rem",
              fontWeight: 600,
              "&:hover": { background: "#2a47c4 !important" },
            }}
          >
            Start free — no credit card →
          </MKButton>
          <MKButton
            size="large"
            component="a"
            href="mailto:support@ringoperator.com?subject=Book%20a%20demo"
            sx={{
              background: "transparent !important",
              color: `${brandCream} !important`,
              border: `1px solid rgba(244,241,234,0.25) !important`,
              px: 3.5,
              py: 2,
              borderRadius: 999,
              fontSize: "1rem",
              fontWeight: 500,
              "&:hover": { background: "rgba(244,241,234,0.08) !important" },
            }}
          >
            Book a demo
          </MKButton>
        </MKBox>

        <MKBox
          className="ro-mono"
          sx={{
            mt: 4,
            fontSize: 12,
            color: "rgba(244,241,234,0.5)",
            textTransform: "uppercase",
            letterSpacing: "0.12em",
          }}
        >
          setup in 30 min · keep your number · 30+ languages
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default FinalCTA;
